import { mapState } from "vuex";
import { Toast } from "vant";

export default {
  data() {
    return {
      // 订单代收货状态（0-全部 1-待收货 2-已收货）
      floorList: [
        {
          id: "0",
          name: "全部"
        },
        {
          id: "1",
          name: "待收货"
        },
        {
          id: "2",
          name: "已收货"
        }
      ],
      floorIndex: 0,
      loading: false,
      finished: false,
      list: [],

      form: {
        queryText: "",
        status: "0",
        current: 1,
        size: 10
      },
      total: 0
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0
    });
    this.getList();
  },
  methods: {
    getList() {
      const { form } = this;
      this.$store.dispatch("order/signature/queryListForPage", form).then((data) => {
        this.loading = false;
        console.log("订单列表", data);
        const { results, total } = data;
        this.list = [...results, ...this.list];
        this.total = total;
        if (!results.length) {
          this.finished = true;
        }
      }).finally(() => {
        Toast.clear();
      });
    },
    floorChange(index, id) {
      this.floorIndex = index;
      this.form.status = id;
      this.list = [];
      this.form.current = 1;
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      this.getList();
    },
    loadMore() {
      console.log("loadMore");
      const { list, total, form } = this;
      if (!list.length) {
        return;
      }
      if (form.current < total) {
        this.loading = true;
        this.form.current += 1;
        this.getList();
      } else {
        this.finished = true;
      }
    },

    routerClick(status, orderId) {
      let url = `/signature?orderId=${orderId}&signType=2&returnUrl=${encodeURIComponent(window.location.href)}`;
      if (status === "2") {
        url = `${url}&source=detail`;
      }
      this.$router.push(url);
    }
  }
};
